"use strict";
var Observable_1 = require('../../Observable');
var scan_1 = require('../../operator/scan');
Observable_1.Observable.prototype.scan = scan_1.scan;
//# sourceMappingURL=scan.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxjs/add/operator/scan.js
// module id = 276
// module chunks = 2